module.exports = __webpack_public_path__ + "media/images/countryrect/ma-2b461b90ab29b3e85a242723e4520f42.svg";